import React, { useContext, useEffect, useRef, useState } from "react";
import { DailyPanditBookingAPI } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import { LoaderContext } from "../../AuthContext/AuthContext";
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../Components/Breadcrumb";
import { t } from "i18next";
import {
  GetPujaLookupList,
  PujaDetailsBySlug,
} from "../../ApiServices/Puja/PujaApi";
import { Helmet } from "react-helmet-async";
import { pujaServiceID, pujaSubServiceID } from "../../Components/enum";
import NoResultFoundModel from "../../Components/NoDataFound/NoDataFoundModal";
import dayjs from "dayjs";
import templeHindu from "../../assets/images/new/temple-hindu.png";
import "./PujaListPageDesign.css";
import { FaFilter } from "react-icons/fa";
import FilterModal from "./FilterModal";
import HoroscopeBannerImg from "../../assets/images/new/banner-remid.jpeg";

const RemedyPujaListPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user_id = localStorage.getItem("userID");

  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedDeity, setSelectedDeity] = useState([]);
  const [selectedBenefits, setSelectedBenefits] = useState([]);
  const [metaDesc, setMetaDesc] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [conrel, setConrel] = useState("");
  const [conhref, setConhref] = useState("");
  const [pujaBannerHeaderName, setPujaBannerHeaderName] = useState(null);

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [searchKeyWord, setSearchKeyWord] = useState(null);
  const [totalRecords, setTotalRecords] = useState(-1);
  const [pujaList, setPujaList] = useState([]);
  const [beneFits, setBeneFits] = useState([]);
  const {
    setLoader,
    loader,
    selectedLanguageID,
    isLanguageUpdate,
    formatToIndianCurrency,
  } = useContext(LoaderContext);

  localStorage.setItem("previousPath", location.pathname);

  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    pujaServiceID: null,
    pujaSubServiceID: null,
    selectedLocations: [],
    selectedDeity: [],
    selectedBenefits: [],
    selectedCount: 0,
    category: 'Location'
  });



  useEffect(() => {
    if (location?.pathname === "/remedy-puja") {
      GetPujaLookupListData(pujaServiceID?.Puja, pujaSubServiceID?.RemedyPuja);
      setMetaTitle("Book Remedy Puja Services Online | Myomnamo")
      setMetaDesc("Find effective spiritual remedies, Navagraha shanti, Vastu correction pujas & personalized rituals with verified pandits at Myomnamo. Book your puja now")
      setConrel("canonical");
      setConhref("https://www.myomnamo.com/remedy-puja");
      setModelRequestData((prev) => ({
        ...prev,
        pujaServiceID: pujaServiceID?.Puja,
        pujaSubServiceID: pujaSubServiceID?.RemedyPuja,
      }));
      setPujaBannerHeaderName("Remedy Puja");
    } else if (location?.pathname === "/homam-puja") {
      GetPujaLookupListData(pujaServiceID?.Puja, pujaSubServiceID?.HomamPuja);
      setMetaTitle("Book Homam & Havan Puja Services Online | Myomnamo")
      setMetaDesc("Perform traditional Homam and Havan fire ceremonies with expert pandits through Myomnamo. Book powerful rituals for peace, prosperity, and spiritual cleansing.")
      setConrel("canonical");
      setConhref("https://www.myomnamo.com/homam-puja");
      setModelRequestData((prev) => ({
        ...prev,
        pujaServiceID: pujaServiceID?.Puja,
        pujaSubServiceID: pujaSubServiceID?.HomamPuja,
      }));
      setPujaBannerHeaderName("Homam Puja");
    } else if (location?.pathname === "/daily-pandit-puja") {
      setMetaTitle("Book Pandits Online for Daily Puja & Rituals | Myomnamo")
      setMetaDesc("Experience daily spiritual pujas at home or temple with qualified pandits through Myomnamo. Schedule rituals, blessings & devotional services easily online.")
      setConrel("canonical");
      setConhref("https://www.myomnamo.com/daily-pandit-puja");
      GetPujaLookupListData(
        pujaServiceID?.PanditPuja,
        pujaSubServiceID?.DailyPanditPuja
      );
      setModelRequestData((prev) => ({
        ...prev,
        pujaServiceID: pujaServiceID?.PanditPuja,
        pujaSubServiceID: pujaSubServiceID?.DailyPanditPuja,
      }));
      setPujaBannerHeaderName("Daily Pandit Puja");
    } else if (location?.pathname === "/remedy-subscription-puja") {
      setMetaTitle("Book Remedy Subscription Puja Services for Remedies | Myomnamo")
      setMetaDesc("Experience the power of sacred remedy pujas performed by learned pandits to remove negative energies. Get divine blessings & bring peace & prosperity into life")
      setConrel("canonical");
      setConhref("https://www.myomnamo.com/remedy-subscription-puja");
      GetPujaLookupListData(
        pujaServiceID?.SankalpPuja,
        pujaSubServiceID?.SubscriptionRemedyPuja
      );
      setModelRequestData((prev) => ({
        ...prev,
        pujaServiceID: pujaServiceID?.SankalpPuja,
        pujaSubServiceID: pujaSubServiceID?.SubscriptionRemedyPuja,
      }));
      setPujaBannerHeaderName("Remedy Subscription Puja");
    } else if (location?.pathname === "/homam-subscription-puja") {
      setMetaTitle("Book Homam Subscription Puja for Havan & Rituals | Myomnamo")
      setMetaDesc("Book Homam subscription puja services at Myomnamo. Experience powerful Vedic fire rituals performed regularly for prosperity, protection, & spiritual growth")
      setConrel("canonical");
      setConhref("https://www.myomnamo.com/homam-subscription-puja");
      GetPujaLookupListData(
        pujaServiceID?.SankalpPuja,
        pujaSubServiceID?.SubscriptionHomamPuja
      );
      setModelRequestData((prev) => ({
        ...prev,
        pujaServiceID: pujaServiceID?.SankalpPuja,
        pujaSubServiceID: pujaSubServiceID?.SubscriptionHomamPuja,
      }));
      setPujaBannerHeaderName("Homam Subscription Puja");
    }
  }, [location]);

  useEffect(() => {
    if (isLanguageUpdate || isFilterApplied) {
      GetPujaLookupListData(
        modelRequestData?.pujaServiceID,
        modelRequestData?.pujaSubServiceID
      );
      setIsFilterApplied(false)
    }
  }, [isLanguageUpdate, isFilterApplied]);

  const GetPujaLookupListData = async (pujaServiceID, pujaSubServiceID) => {
    setLoader(true);
    try {
      const response = await GetPujaLookupList({
        pujaCatKeyID: null,
        applangID: selectedLanguageID,
        pujaServiceID: pujaServiceID,
        pujaSubServiceID: pujaSubServiceID,
        templeID: null,
        deityIDs: modelRequestData?.selectedDeity || [],
        benefitsIDs: modelRequestData?.selectedBenefits || [],
        districtIDs: modelRequestData?.selectedLocations || [],
      });

      if (response?.statusCode === 200) {
        const list = response?.responseData?.data;

        setPujaList(list);
        setTotalRecords(list?.length);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const viewDetail = (puja) => {
    const newSlug = puja?.pujaSlug;
    if (location?.pathname === "/remedy-puja") {
      navigate(`/service/remedy-puja-details/${newSlug}`, {
        state: {
          puja: puja,
          isRemedySubscription:
            location?.pathname === "/remedy-subscription-puja" ? true : false,
          isHomamSubscription:
            location?.pathname === "/homam-subscription-puja" ? true : false,
        },
      });
    } else if (location?.pathname === "/homam-puja") {
      navigate(`/service/homam-puja-details/${newSlug}`, {
        state: {
          puja: puja,
          isRemedySubscription:
            location?.pathname === "/remedy-subscription-puja" ? true : false,
          isHomamSubscription:
            location?.pathname === "/homam-subscription-puja" ? true : false,
        },
      });
    } else if (location?.pathname === "/daily-pandit-puja") {
      navigate(`/service/daily-pandit-puja-details/${newSlug}`, {
        state: {
          puja: puja,
          isRemedySubscription:
            location?.pathname === "/remedy-subscription-puja" ? true : false,
          isHomamSubscription:
            location?.pathname === "/homam-subscription-puja" ? true : false,
        },
      });
    } else if (location?.pathname === "/remedy-subscription-puja") {
      navigate(`/service/subscription-remedy-puja-details/${newSlug}`, {
        state: {
          puja: puja,
          isRemedySubscription:
            location?.pathname === "/remedy-subscription-puja" ? true : false,
          isHomamSubscription:
            location?.pathname === "/homam-subscription-puja" ? true : false,
        },
      });
    } else if (location?.pathname === "/homam-subscription-puja") {
      navigate(`/service/subscription-homam-puja-details/${newSlug}`, {
        state: {
          puja: puja,
          isRemedySubscription:
            location?.pathname === "/remedy-subscription-puja" ? true : false,
          isHomamSubscription:
            location?.pathname === "/homam-subscription-puja" ? true : false,
        },
      });
    } else {
      navigate(`/service/puja-details/${newSlug}`, {
        state: {
          puja: puja,
          isRemedySubscription:
            location?.pathname === "/remedy-subscription-puja" ? true : false,
          isHomamSubscription:
            location?.pathname === "/homam-subscription-puja" ? true : false,
        },
      });
    }



  };

  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };

  const handleSearch = (value) => {

  };

  function useDebouncedCallback(callback, delay) {
    const timer = useRef(null);

    return (...args) => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }
  // Create a debounced version of handleSearch
  const debouncedSearch = useDebouncedCallback(handleSearch, 500);

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchKeyWord(value); // Update the input value immediately
    debouncedSearch(value); // Run search only after 500 ms pause
  };

  const handleFilterClicked = (module) => {
    setModelRequestData((prev) => ({ ...prev, category: module }))
    setShowFilterModal(true);
  };
  return (
    <>


      <Helmet>
        <title>
          {metaTitle}
        </title>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta
          name="description"
          content={metaDesc}
        />
        <link rel={conrel} href={conhref} />
        <meta
          property="og:title"
          content={metaTitle}
        />
        <meta
          property="og:description"
          content={metaDesc}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={metaTitle}
        />
        <meta
          name="twitter:description"
          content={metaDesc}
        />

      </Helmet>
      <section className="page-header" style={{ paddingBottom: '35px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">{t(pujaBannerHeaderName)}</h2>
          <div className="d-flex justify-content-center">
            <Breadcrumbs />
          </div>
        </div>
      </section>
      <div
        className="container mt-4 mb-3"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="d-flex justify-content-center align-items-center mb-2">
          {/* Left: Breadcrumbs */}


          {/* Right: Filter button */}
          {modelRequestData?.pujaSubServiceID !== 5 &&
            modelRequestData?.pujaSubServiceID !== 6 && (
              <div className="d-flex gap-3 mb-1 justify-content-center flex-wrap">
                {/* Filter button */}
                <button
                  type="button"
                  className="d-flex align-items-center gap-2 px-4 py-2 mainFilter"

                  onClick={() => handleFilterClicked("Location")}
                >
                  <i className="bi bi-sliders" style={{ fontSize: "18px" }}></i>
                  {t("Filter")}
                  {modelRequestData?.selectedCount > 0 && (
                    <span
                      className="badge ms-1 badgeCount"

                    >
                      {modelRequestData?.selectedCount}
                    </span>
                  )}
                </button>

                {/* Location */}
                <button
                  type="button"
                  className="d-flex align-items-center gap-2 px-4 py-2 locationFilter"

                  onClick={() => handleFilterClicked("Location")}
                >
                  {t("Location")}
                  {modelRequestData?.selectedLocations?.length > 0 && (
                    <span
                      className="badge ms-1 badgeCount"

                    >
                      {modelRequestData?.selectedLocations?.length}
                    </span>
                  )}
                  <i className="bi bi-chevron-down" style={{ fontSize: "14px" }}></i>
                </button>

                {/* Benefits */}
                <button
                  type="button"
                  className="d-flex align-items-center gap-2 px-4 py-2 benefitFilter"

                  onClick={() => handleFilterClicked("Benefits")}
                >
                  {t("Benefits")}
                  {modelRequestData?.selectedBenefits?.length > 0 && (
                    <span
                      className="badge ms-1 badgeCount"

                    >
                      {modelRequestData?.selectedBenefits?.length}
                    </span>
                  )}
                  <i className="bi bi-chevron-down" style={{ fontSize: "14px" }}></i>
                </button>

                {/* Deity */}
                <button
                  type="button"
                  className="d-flex align-items-center gap-2 px-4 py-2 deityFilter"
                  onClick={() => handleFilterClicked("Deity")}
                >
                  {t("Deity")}
                  {modelRequestData?.selectedDeity?.length > 0 && (
                    <span
                      className="badge ms-1 badgeCount"

                    >
                      {modelRequestData?.selectedDeity?.length}
                    </span>
                  )}
                  <i className="bi bi-chevron-down" style={{ fontSize: "14px" }}></i>
                </button>
              </div>
            )}
        </div>

        {/* <div className="row ">
                    <div className="col-md-6 mx-auto mb-3">
                        <div
                            className="search-box"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flex: "1",
                                maxWidth: "100%",
                                marginRight: "10px",
                                position: "relative",
                            }}
                        >
                            <input
                                type="text"
                                className="custom-search-input"
                                placeholder="Search"
                                value={searchKeyWord}
                                onChange={handleChange}
                                style={{
                                    padding: "8px 35px 8px 10px",
                                    width: "100%",
                                }}
                            />
                            <span

                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    cursor: "pointer",
                                    color: "#a52444",
                                }}
                            >
                                <i className="fas fa-search"></i>
                            </span>
                        </div>
                    </div>
                </div> */}

        <div className="row justify-content-start">
          {pujaList.map((puja, index) => (
            <div className="col-md-4 col-lg-4 d-flex mb-2 cursor-pointer" data-aos="fade-up"
              key={index}
              onClick={() => viewDetail(puja)}
              style={{ cursor: 'pointer' }}
            >


              <div
                className="blog-card wow fadeInUp d-flex flex-column h-100"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
                style={{
                  "--accent-color": "#FF5528", width: '100%'
                }}
              >
                <div className="blog-card__image" >
                  <img src={puja.pujaImageUrl || pandit} alt={puja.pujaName} style={{ objectFit: 'fill ' }} />
                  <img src={puja.pujaImageUrl || pandit} alt={puja.pujaName} style={{ objectFit: 'fill ' }} />.
                  <div
                    onClick={() => viewDetail(puja)}
                    className="blog-card__image__link"
                  >
                    <span className="sr-only">{puja.pujaName}</span>
                  </div>
                  {puja?.pujaDate !== null && puja?.pujaDate !== undefined && (
                    <div className="blog-card__date">
                      <i className="icofont-ui-calendar"></i>
                      {puja?.pujaDate ? puja?.pujaDate : ""}
                    </div>
                  )}

                </div>

                <div className="blog-card__content flex-grow-1 d-flex flex-column p-1">


                  <h6
                    className="mx-2 fw-bold my-1"
                    style={{ fontSize: "17px" }}
                  >

                    {puja.pujaName}

                  </h6>

                  {location?.pathname !== "/daily-pandit-puja" && (
                    <div
                      className="d-flex align-items-start flex-wrap"
                      style={{ maxWidth: "100%", overflow: "hidden" }}
                    >
                      <img
                        src={templeHindu}
                        alt="temple"
                        className="img-fluid me-2"
                        style={{
                          objectFit: "contain",
                          width: "24px",
                          height: "24px",
                          flexShrink: 0,
                          marginLeft: "10px", // prevents icon from shrinking
                        }}
                      />
                      <small
                        className="text-muted location-text"
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                          flex: 1, // allows text to take remaining space
                          minWidth: 0, // required to allow wrapping in flexbox
                        }}
                      >
                        {puja.templeAddress}
                      </small>
                    </div>

                  )}

                  <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
                    {puja?.benefits?.split(",").map((benefit, i) => (
                      <span
                        key={i}
                        style={{
                          background: "#f4b72233",
                          color: "#991b3d",
                          fontSize: "12px",
                          padding: "4px 10px",
                          borderRadius: "12px",
                        }}
                      >
                        {benefit.trim()}
                      </span>
                    ))}
                  </div>

                  <div className="mt-auto">
                    {location?.pathname !== "/remedy-subscription-puja" &&
                      location?.pathname !== "/homam-subscription-puja" && (
                        <span
                          className="fw-bold"
                          style={{ fontSize: "16px", color: "#000" }}
                        >
                          <span className="mx-1"> ₹ </span>{" "}
                          {puja.onlinePujaPrice
                            ? formatToIndianCurrency(
                              Math.round(
                                puja.onlinePujaPrice -
                                (puja.onlinePujaDiscountAmount || 0)
                              )
                            )
                            : formatToIndianCurrency(
                              Math.round(
                                puja.offlinePujaPrice -
                                (puja.offlinePujaDiscountAmount || 0)
                              )
                            )}
                        </span>
                      )}

                    <button
                      className="btn w-100 mt-2 book-btn"

                    >
                      <span
                        className="blink-text"
                        onClick={() => viewDetail(puja)}
                      >
                        {t("Book Puja Now")}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {totalRecords <= 0 && (
            <NoResultFoundModel totalRecords={totalRecords} />
          )}
        </div>
      </div>
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
        setIsFilterApplied={setIsFilterApplied}
      />
    </>
  );
};

export default RemedyPujaListPage;
